import { supabase } from './supabase';
import { uploadImageToBucketCore } from '@gv/core';

async function compressImage(file: File, maxDim = 512, quality = 0.8): Promise<Blob> {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
        const i = new Image();
        i.onload = () => resolve(i);
        i.onerror = reject;
        i.src = URL.createObjectURL(file);
    });
    const w = img.width;
    const h = img.height;
    const scale = Math.min(1, maxDim / Math.max(w, h));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(w * scale);
    canvas.height = Math.round(h * scale);
    const ctx = canvas.getContext('2d')!;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return await new Promise<Blob>((resolve) => canvas.toBlob((b) => resolve(b as Blob), 'image/jpeg', quality));
}

export async function uploadCompressedImage(file: File, folder = 'uploads') {
    const blob = await compressImage(file);
    // Delegate to core to handle storage upload and public URL generation
    return uploadImageToBucketCore(supabase as any, blob, folder, 'image/jpeg');
}
